import { observable, action, computed } from "mobx";

class ConfirmationModalStore {

  @observable visible = false;
  @observable modalData = {
    title: "",
    body: "",
    confirmText: "Yes",
    rejectText: "No",
    onConfirm: () => {},
  };

  @action
  toggleVisibility = () => {
    this.visible = !this.visible;
  };

  @action
  setModalData = data => {
    this.modalData = data;
  };

  @computed
  get getModalData() {
    return this.modalData;
  }

  @computed
  get isVisible() {
    return this.visible;
  }
}

const confirmationModalStore = new ConfirmationModalStore();
export default confirmationModalStore;